<template>
    <v-dialog
        v-model="emptyPhenotypeOpen"
        :fullscreen="$vuetify.display.mobile"
        :width="$vuetify.display.mobile ? '100%' : '588'"
        class="empty-phenotype-modal"
        >
        <v-card class="inside-empty-phenotype-modal px-4 d-flex flex-column">
            <div class="header d-flex flex-row justify-space-between align-center">
                <div class="modal-header mt-4 mb-5">{{$t('reservation.fill_phenotype_before_header')}}</div>
                <v-btn flat icon color="transparent" size="x-small" class="modal-close" @click="emptyPhenotypeOpen = false">
                    <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
                </v-btn>
            </div>
          
            <div class="modal-text mb-0 mb-md-10">
                {{$t('reservation.fill_phenotype_before_text')}}
            </div>
            <v-spacer></v-spacer>
            <div class="modal-buttons text-right">
                <v-btn
                    height="40"
                    :width="$vuetify.display.mobile ? '100%' : 'auto'"
                    color="primary"
                    flat
                    rounded
                    class="mb-4 ml-md-0 px-6"
                    @click="redirectAndClose()"
                    >{{ hasPhenotypeMode('own') ? $t('recipient.add_partner_phenotype_btn') : $t('recipient.add_own_phenotype_btn')}}</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { useStore } from "vuex";
import { useRoute } from 'vue-router'
import { computed } from "vue";
import router from "@/router";

export default {
    name: 'empty-phenotype-dialog-component',
    props: ['modelValue'],
    setup(props, { emit }) { 
        const store = useStore()
        const routeName =  useRoute().name
        const routePath =  useRoute().fullPath
        const emptyPhenotypeOpen = computed({ 
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        })

        return {
            emptyPhenotypeOpen,
            hasPhenotypeMode: (mode) => store.getters["phenotypeModule/hasPhenotypeMode"](mode),
            goToPhenotype: () => {
                store.dispatch('phenotypeModule/setReturnRoute', {name: routeName, path: routePath, reservation: true}).then(() => {
                    store.dispatch('phenotypeModule/setCurrentPhenotype', 'own').then(() => {
                        router.push({ name: 'dashboardView', query: {selected: "phenotype"} })
                    })
                })
            }
        }
    },
    methods: {
        redirectAndClose(){
            this.goToPhenotype();
            this.$emit('close');
            this.emptyPhenotypeOpen = false;
        }
    }
}
</script>

<style scoped lang="scss">
.inside-empty-phenotype-modal
{
    min-width: 650px;
    min-height: 270px;
}
.empty-phenotype-modal {
    .modal {
        &-header {
            @include nsb-font-main-header;
            font-size: 23px !important;
        }
        &-text {
        @include nsb-font-container;
            font-size: 14px !important;
            line-height: 21px !important;
        }
        &-buttons {
            @include nsb-font-button;
            line-height: 21px !important;
        }
    }
}
</style>